<template>
    <v-container>
      <v-card class="pa-5">
        <v-card-title>Профиль пользователя</v-card-title>
        <v-card-text>
          <div>Ваш ник: <strong>{{ username }}</strong></div>
          <v-btn color="red" class="mt-3" @click="$emit('logout')">Выйти</v-btn>
        </v-card-text>
      </v-card>
    </v-container>
  </template>
  
  <script>
  export default {
    data() {
      return {
        username: 'Admin',  // Здесь можете подключить реальный ник из данных пользователя
      };
    },
  };
  </script>
  